import React from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";

const Summary = () => {
  const { onboardingProfile } = useOnboarding();

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-3">Account Type</h3>
          <p className="text-gray-700 capitalize">{onboardingProfile.account_type || "Not set"}</p>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <h3 className="font-semibold text-gray-900 mb-3">Contact Information</h3>
          <div className="space-y-2 text-sm">
            <p>
              <span className="text-gray-600">Phone Number:</span>{" "}
              <span className="text-gray-900 font-medium">
                {onboardingProfile.phone_number || "Not provided"}
              </span>
            </p>
          </div>
        </div>

        {onboardingProfile.account_type === "carrier" && (
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-semibold text-gray-900 mb-3">Authority</h3>
            <div className="space-y-2 text-sm">
              <p>
                <span className="text-gray-600">DOT Number:</span>{" "}
                <span className="text-gray-900 font-medium">
                  {onboardingProfile.dot_number || "Not provided"}
                </span>
              </p>
              <p>
                <span className="text-gray-600">Status:</span>{" "}
                <span
                  className={`font-medium ${onboardingProfile.dot_authorized
                      ? "text-green-600"
                      : "text-red-600"
                    }`}
                >
                  {onboardingProfile.dot_authorized ? "✓ Verified" : "Not verified"}
                </span>
              </p>
            </div>
          </div>
        )}

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            You can add company name, equipment, integrations, and other details later in your
            profile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;

